/**
 * RSA 公钥配置
 * 用于加密 AES 密钥
 *
 * 注意：请替换为实际的 RSA-2048 公钥
 */

export const RSA_PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAjt5bbwe4P9hUkXFzWE7T
bunvibc+5hnpg4Tdt9Nn2WdUz2ILaDn5OwIOZuvra7EIpDMxbuVfWUsA+Dx1P5Be
LU/hBgnOJ67ZdchCqpLiwmu7XmGih6XKNL1CaTrUB1RpN0MVSgA1UKNcRdK9fnAG
gUs1L6e45CYV7kQIi5NH1fTsIq/U8lIBgCH4p2gfM+GpXmAeklFu5d8LqjUU0egw
pujBbTUDLaGj39wmw75ZNfC9xktq7ghOs1uJMAf48PS3y6Qnn4waHmry2nJSNic8
P0FK8rk+vkCcEqXAOUAkEqLfbi1ix4AUWPgYHAUsY3jeIRVBj650w+HmOvNZvVyT
WQIDAQAB
-----END PUBLIC KEY-----`

// 注意：上面是示例公钥，请替换为实际的 RSA-2048 公钥
// TODO: 从后端获取或配置实际的 RSA 公钥
